<div class="page-title">
  <div class="title">
    <h3>{{ 'cancel-insurance-reason.title'| translate: { petName: petData.pet_name } }}</h3>
  </div>
</div>

<div class="text">
  <p class="body-16">{{ 'cancel-insurance-reason.text'| translate }}</p>
</div>

<div class="form">
  <div class="row">
    <div class="inline-select">
      <mat-select class="input" [(ngModel)]="selectedReason"
        [placeholder]="'cancel-insurance-reason.select-placeholder' | translate">
        @for (reason of reasons; track reason) {
          <mat-option [value]="reason">{{ ('cancel-insurance-reason.reasons.' + reason) | translate }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
</div>

@if (selectedReason && !isPetReason(selectedReason)) {
  <div class="form">
    <div class="row">
      <div class="title">
        <p class="subtitle-14">{{ 'cancel-insurance-reason.cancellation-type-text' | translate }}</p>
      </div>
      <div class="inline-select">
        <label for="end-of-insurance-year" [class.selected]="cancellationType === 'end-of-insurance-year'">
          <input id="end-of-insurance-year" type="radio" value="end-of-insurance-year" [(ngModel)]="cancellationType">
          <span>{{ 'cancel-insurance-reason.cancellation-type-end-of-insurance-year' | translate }}</span>
        </label>
        <label for="end-of-month" [class.selected]="cancellationType === 'end-of-month'">
          <input id="end-of-month" type="radio" value="end-of-month" [(ngModel)]="cancellationType">
          <span>{{ 'cancel-insurance-reason.cancellation-type-end-of-month' | translate }}</span>
        </label>
      </div>
    </div>
    @if (cancellationType === 'end-of-month') {
      <div class="row form-field">
        <div class="input">
          <div class="form-field-date">
            <input matInput
              class="input"
              placeholder="{{ 'cancel-insurance-reason.date-placeholder' | translate }}"
              [matDatepicker]="cancellationDatePicker"
              [matDatepickerFilter]="cancellationDateFilter"
              (click)="cancellationDatePicker.open()"
              [(ngModel)]="cancellationDate">
            <mat-datepicker-toggle matSuffix [for]="cancellationDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #cancellationDatePicker></mat-datepicker>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="info-block">
    <div class="header">
      <div class="title">
        <p class="body-16">{{ 'cancel-insurance-reason.cancellation-type-text-title' | translate }}</p>
      </div>
    </div>
    <div class="text">
      <ul>
        <li class="body-14"
          [innerHTML]="'cancel-insurance-reason.cancellation-type-text-point-1' | translate : { petName: petData.pet_name }">
        </li>
        <li class="body-14"
          [innerHTML]="'cancel-insurance-reason.cancellation-type-text-point-2' | translate : { petName: petData.pet_name }">
        </li>
        <li class="body-14" [innerHTML]="'cancel-insurance-reason.cancellation-type-text-point-3' | translate">
        </li>
      </ul>
    </div>
  </div>
}

@if (selectedReason === 'pet-missing') {
  <div class="info-block">
    <div class="header">
      <div class="title">
        <p class="body-16">{{ 'cancel-insurance-reason.pet-missing-title' | translate }}</p>
      </div>
    </div>
    <div class="text">
      <ul>
        <li class="body-14"
          [innerHTML]="'cancel-insurance-reason.pet-missing-message' | translate">
        </li>
      </ul>
    </div>
  </div>
}

@if (selectedReason === 'pet-deceased') {
  <div class="info-block">
    <div class="header">
      <div class="title">
        <p class="body-16">{{ 'cancel-insurance-reason.pet-deceased-title' | translate }}</p>
      </div>
    </div>
    <div class="text">
      <p
      class="body-14">{{ 'cancel-insurance-reason.pet-deceased-message' | translate: { petName: petData.pet_name } }}</p>
    </div>
  </div>
  <div class="text">
    <p
    class="body-14">{{ 'cancel-insurance-reason.pet-deceased-date-title' | translate: { petName: petData.pet_name } }}</p>
  </div>
  <div class="form">
    <div class="row form-field">
      <div class="input">
        <div class="form-field-date">
          <input matInput
            class="input"
            placeholder="{{ 'cancel-insurance-reason.date-placeholder' | translate }}"
            [matDatepicker]="petDeceasedDatePicker"
            [max]="today"
            (click)="petDeceasedDatePicker.open()"
            [(ngModel)]="petDeceasedDate">
          <mat-datepicker-toggle matSuffix [for]="petDeceasedDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #petDeceasedDatePicker></mat-datepicker>
        </div>
      </div>
    </div>
  </div>
}

<div class="flex-placeholder"></div>

<div class="actions">
  <button class="button primary" (click)="navigateBack()">
    {{ 'cancel-insurance-reason.buttons.cancel' | translate }}
  </button>

  <button class="button white" (click)="cancelInsurance()" [class.disabled]="submitButtonDisabled()"
    [disabled]="submitButtonDisabled()">
    {{ 'cancel-insurance-reason.buttons.submit' | translate }}
    @if (sending) {
      <mat-spinner diameter="18"></mat-spinner>
    }
  </button>
</div>
